import useModal from '../hooks/useModal';
import JoinCourseModal from './modals/join-course-modal';
import { Button } from './ui/button';

const JoinCourse = () => {
  const [modal, showModal] = useModal();
  return (
    <div className="flex justify-end">
      {modal}
      <Button
        onClick={() => {
          showModal('강좌 참여', onClose => <JoinCourseModal onClose={onClose} />);
        }}
        type="button"
      >
        강좌 참여
      </Button>
    </div>
  );
};

export default JoinCourse;
